import {Config} from 'src/config'
import {PageContainer} from '../layout'

interface Props {
  children?: JSX.Element | null
  label: string
  title?: string
}

export const PageContent = ({
  children,
  title = Config.title,
  label,
}: Props): JSX.Element => (
  <PageContainer title={`${label} - ${title}`}>{children}</PageContainer>
)
